import PropTypes from 'prop-types';
import { IconJsxer } from '../../helpers/IconHelper';
import './FeatureChainHeaderControls.scss';

const FeatureChainHeaderControls = ({ canStart, canStop, canSkip, onStart, onStop, onSkip }) => {
    const renderAction = (actionClass, icon, enabled, onClick, label) => (
        <button
            type="button"
            className={`feature-chain-header-action ${actionClass}${enabled ? ' is-enabled' : ''}`}
            onClick={(e) => {
                e.stopPropagation();
                if (enabled) {
                    onClick?.(e);
                }
            }}
            disabled={!enabled}
            aria-label={label}
            title={label}
        >
            {IconJsxer.GetIcon(icon, IconJsxer.ICON_STYLES.campaignPanelInfoPill)}
        </button>
    );

    return (
        <div className="feature-chain-header-controls" onClick={(e) => e.stopPropagation()}>
            {renderAction('play', IconJsxer.ICONS.play, canStart, onStart, 'Start chain')}
            {renderAction('stop', IconJsxer.ICONS.stop, canStop, onStop, 'Stop chain')}
            {renderAction('skip', IconJsxer.ICONS.skip, canSkip, onSkip, 'Skip chain step')}
        </div>
    );
};

FeatureChainHeaderControls.propTypes = {
    canStart: PropTypes.bool,
    canStop: PropTypes.bool,
    canSkip: PropTypes.bool,
    onStart: PropTypes.func,
    onStop: PropTypes.func,
    onSkip: PropTypes.func,
};

FeatureChainHeaderControls.defaultProps = {
    canStart: false,
    canStop: false,
    canSkip: false,
    onStart: null,
    onStop: null,
    onSkip: null,
};

export default FeatureChainHeaderControls;
